
export const FETCH_WORKLIST = "[MRT] FETCH_WORKLIST";
export const FETCH_WORKLIST_START = "[MRT] FETCH_WORKLIST_START";
export const FETCH_WORKLIST_SUCCESS = "[MRT] FETCH_WORKLIST_SUCCESS";
export const FETCH_WORKLIST_ERROR = "[MRT] FETCH_WORKLIST_ERROR";
export const SET_WORKLIST_FILTER = "[MRT] SET_WORKLIST_FILTER";
export const REMOVE_LOCKED_VISIT = "[MRT] REMOVE_LOCKED_VISIT";

export const SET_WORKLIST_AUTO_NEXT_VISIT = "[MRT] SET_WORKLIST_AUTO_NEXT_VISIT";
export const SET_WORKLIST_PAGINATION = "[MRT] SET_WORKLIST_PAGINATION";

export const VIEW_WORKLIST_VISIT_LOADING_START = "[MRT] VIEW_WORKLIST_VISIT_LOADING_START";
export const VIEW_WORKLIST_VISIT_LOADING_END = "[MRT] VIEW_WORKLIST_VISIT_LOADING_END";
export const RESET_WORKLIST_FILTER = "[MRT] RESET_WORKLIST_FILTER";

export const fetchMrtWorklist = (payload) => {
    return {
        type: FETCH_WORKLIST,
        payload
    };
};

export const setMrtWorklistfilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_WORKLIST_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const setWorklistAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_WORKLIST_AUTO_NEXT_VISIT,
        autoNextVisit
    }
}

export const resetWorklistFilter = () => {
    return {
        type: RESET_WORKLIST_FILTER,
    };
}